import { get } from 'services/api';
import { API_V4_BASE_URL } from 'settings';

import { increaseLoading, decreaseLoading } from './loading';

const receiveUpsells = (upsells: Array<any>) => ({
  type: 'RECEIVE_UPSELLS',
  upsells,
});

export const cleanUpsells = () => (dispatch: any) =>
  dispatch({
    type: 'CLEAN_UPSELLS',
  });

export const fetchUpsells = (courseHash: string, lessonID: number) => (dispatch: any) => {
  dispatch(increaseLoading());
  let urlRequest = lessonID ? `/learner/lessons/${lessonID}/upsell` : `/learner/course/${courseHash}/upsell`;

  get({
    url: urlRequest,
    baseURL: API_V4_BASE_URL,
    validateStatus: () => {
      //Ignore any error
      return true;
    },
  }).then(
    (res) => {
      dispatch(receiveUpsells(res.data.data || []));
      dispatch(decreaseLoading());
    },
    () => dispatch(decreaseLoading())
  );
};
